export const actions = () => ({
  setData(data) {
    Object.assign(this, data)
  },
})
